import { axios, Response } from '../index'

const updateMemberStatus = (
  groupId: string,
  memberId: string,
  newStatus: string
): Response<Body> => {
  return axios.put(`/v1/groups/${groupId}/members/${memberId}`, {
    status: newStatus
  })
}

export default updateMemberStatus
